window.onload = function() {

 if(version=='v2'){
    // this has to be in the doc. ready in order for the htmltocanvas to work. I don't really get why.
    $(".rels div strong").attr("contenteditable", "true");
  }
  "use strict";
  var delay = (function() {
    var timer = 0;
    return function(callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();
  if(presetcm.indexOf('|')!==-1){
    var bits = presetcm.split('|');
    if($.isNumeric(bits[1])){
      presetcm2 = bits[1];
    }
    if($.isNumeric(bits[0])){    
      presetcm = bits[0];
    }
  }
  if(presetcm > 3720){
    presetcm = 3720
  } else if(presetcm <0){
    presetcm = 0;
  }

 if(typeof(presetcm2)!=='undefined'){
  if(presetcm2 > 3720){
    presetcm2 = 3720
  } else if(presetcm2 <0){
    presetcm2 = 0;
  }  
 }

  if($.isNumeric(presetcm)){
    $("#percentagecompare").val(getPercentageFromcMs(presetcm));
  }
  if(typeof(presetcm2)!=='undefined'){
    if($.isNumeric(presetcm2)){
       $("#percentagecompare2").val(getPercentageFromcMs(presetcm2));
    }
  }  
  if(typeof(presetrel)!=='undefined'){
    applyPresetRel(presetrel);
  }
 
  $(".reset").on("click", function(e) {
    e.preventDefault();
    $(this).prev().val("");
    resetChart();   
  });
  if(version!='v2'){
    $(".rels > li").on('click', function(){
      var thisrel = $(this).find('strong').text();
      if(!$(this).hasClass('nodata') && !$(this).hasClass('dotted')){
        openHistogram(thisrel);  
      }
    });
    $("#maincontent #most-probable-rels").on('click', 'li span em', function(){
        var thisrel = $(this).text();
        openHistogram(thisrel);
    });
  }

$("#modal").on('click', function(e){
  if(e.target.id=='modal-inner' || e.target.id=='modal'){
    closeModal();
  }
}); 

 $(".percentage").on("click", function(e) {
    e.preventDefault();    
    var text = $(this).text();
     $(this).text(
        text == "or enter %" ? "hide %" : "or enter %");
    $(this).next().slideToggle();
  });

  $("#percentagecompare, #percentagecompare2").on("keyup", function(e) {
    if ($(this).val() > 100 
        && e.keyCode != 46 // delete
        && e.keyCode != 8 // backspace
       ) {
       e.preventDefault();
       $(this).val(100);
    }
    var convertedval = getcMsFromPercentage($(this).val());
    if(convertedval > 3720){
      convertedval = 3720;
    }
    if($(this).attr('id')=='percentagecompare'){
      $("#compare").val(convertedval);
    }
    else if($(this).attr('id')=='percentagecompare2'){
      $("#compare2").val(convertedval);
    }    
    delay(function() {
    var currentval = parseFloat($("#compare").val());
     filterChart(currentval);
     updateShareLink(currentval);
    }, 500);
    updateShareLink(convertedval);
  });

    $(".floater").on("click", ".dpclose", function(e) {
            e.preventDefault();
            closeModal();
    });
     $(document).keyup(function(e) {
        if (e.which == 27 && $('body').hasClass('form-toggled')) {
          closeModal();
        }

        if(document.activeElement.tagName=='EM' && e.which==13){
          openHistogram(document.activeElement.innerText)
        }
        else if(document.activeElement.tagName=='LI' && e.which==13){
          if(typeof(document.activeElement.firstElementChild.firstElementChild)!=='undefined'){
            openHistogram(document.activeElement.firstElementChild.firstElementChild.innerText)
          }
        }



    });


  $("#compare, #compare2").on("keyup", function(e) {
    if ($(this).val() > 3720 
        && e.keyCode != 46 // delete
        && e.keyCode != 8 // backspace
       ) {
       e.preventDefault();
       //setTimeout(function(){
         $(this).val(3720);
       //},100);
    }
    
    var currentval = parseFloat($("#compare").val());

    if($.isNumeric(currentval)){
      var convertedval = getPercentageFromcMs(currentval);
    }
    $("#percentagecompare").val(convertedval);
    if($.isNumeric(currentval)){
        delay(function() {
        var currentval = parseFloat($("#compare").val());     
         filterChart(currentval);
         updateShareLink(currentval);
        }, 500);
    }
  });


  if($.isNumeric(presetcm)){
    //console.log(presetcm);
    $("#compare").val(presetcm);
    if(typeof(presetcm2)!=='undefined'){
      $("#compare2").val(presetcm2);
    }
    delay(function() {
       filterChart(parseFloat(presetcm));
    },500);
  }
  //ipad hack
  setTimeout(function(){
  $("ul li.pad7").css('position', 'relative');
  }, 50);

  $("#printSharedcM").click(function(e) {
        e.preventDefault();
        if($("#edittitle").text()=='Enter your custom title here'){
          $("#edittitle").hide();
        }
        $(".np").hide();

        html2canvas($("body"), {
            onrendered: function(canvas) {

                theCanvas = canvas;
                canvas.toBlob(function(blob) {
                    saveAs(blob, "sharedcm.png");
                });
            }
        });
        $(".np").show();
        $("#edittitle").show();

    });


};// end onload

function applyPresetRel(rel){
  // find it 
  //$(".rels li").removeClass('hilite');
   $(".rels li").each(function(index){
        var myrel = $(this).find('strong').text();
        if(myrel.toLowerCase() == rel.toLowerCase() && myrel.toLowerCase()!=''){
          $(this).addClass('hilite');
          return true;
        }
    });

}

function closeModal(){
    $('body').removeClass('form-toggled');
    $(".floater").hide();
}
function updateShareLink(currentval){
  if($.isNumeric(currentval)){

    if(version=='-double' && $.isNumeric($("#compare2").val())){
      currentval = currentval + '|' +$("#compare2").val();
    }

    $("#currentamount").attr('href',siteurl+'/tools/sharedcm'+version+'/'+currentval);
    var thispath = 'probability';
    if(version=='v4-beta'){
      thispath = 'wato';
    }
    $("#currentamount2").attr('href',siteurl+'/tools/'+thispath+'/cm/'+currentval);

  }
  else {
    $("#currentamount").attr('href',siteurl+'/tools/sharedcm'+version+'/');
  }
}
function getcMsFromPercentage(percentage){
  return parseFloat((7440/100) * percentage).toFixed(0);
}

function getPercentageFromcMs(cms){
  return parseFloat((cms/7440) * 100).toFixed(2);
}

function openHistogram(rel){
  if(rel=='SELF' ){
    return false;
  }
  rel = rel.replace(' †','');
  rel = rel.replace(' or more distant','');

  var relstring = shortenRel(rel);   
  //var src = siteurl+'/assets/tools/shared/histograms/'+relstring+'.png';
  $('body').addClass('form-toggled');
  $("#histogram .histrel").text(rel);
  $("#lowerChart").css('display','block');  
  if(rel=='Parent' || rel=='Child'){
    $("#rtipslink").css('display','none');    
  }
  else {
      $("#rtipslink").css('display','inline');    
  }
 
  //$("#histogram img").attr('src', src );
  $("#histogram").css('display','block');
  generateChart(relstring, rel);
}

function generateChart(rel, relname){
	$("#PercChart").css('display','none');
	$("#noChart").css('display','none');
	var mybins = 'r_'+rel+'_bins';
	var myfreq = 'r_'+rel+'_freq';
	var mymean = 'r_'+rel+'_mean';
	var mysd = 'r_'+rel+'_sd';
	var chartStatus = Chart.getChart("myChart"); // <canvas> id
	if (chartStatus != undefined) {
	  chartStatus.destroy();
	}
	if(typeof(scm.hdata[mybins])==='undefined'){
		$("#noChart").css('display','block');
  		$("#lowerChart").css('display','none');  
		return false;
	}
	increment = scm.hdata[mybins][1]-scm.hdata[mybins][0];
	currentIncrement = false;
	var maxvalue = Math.max.apply(null, scm.hdata[myfreq]);
	var currentcm = false;
	var lowerPerc = 0;
	var upperPerc = 0;
	var totalCases = 0;
    for(var i in scm.hdata[myfreq]){
    	totalCases +=scm.hdata[myfreq][i];
    }
		
	if(!isNaN(document.getElementById('compare').value) && document.getElementById('compare').value!=''){
		currentcm = document.getElementById('compare').value;
		currentIncrement = Math.ceil((parseInt(currentcm)+increment-scm.hdata[mybins][0])/increment)-1;
    currentIncrement2 = false;
    if(version=='-double'){
      if($.isNumeric($("#compare2").val())){
        currentIncrement2 = Math.ceil((parseInt($("#compare2").val())+increment-scm.hdata[mybins][0])/increment)-1;
      }
    }
		var showArrows = true;
    var currentnumberstring = $("#compare").val();

    if(version=='-double' && $.isNumeric($("#compare2").val())){
        currentnumberstring +=' and ' +$("#compare2").val();
        $("#hnote").html('<h3>The amounts you entered were <strong>'+$("#compare").val()+'cM</strong> and <strong>'+$("#compare2").val()+'cM</strong></h3>').css('display','block');   
    }
    else {
        $("#hnote").html('<h3>The amount you entered was <strong>'+$("#compare").val()+'cM</strong></h3>').css('display','block');
    }
		if(currentIncrement >=0 && currentIncrement <= scm.hdata[mybins].length-1){
			if(version=='-double' && $.isNumeric($("#compare2").val())){
        $("#hnote").html($("#hnote").html() + '<ul><li>The red arrows show how these compare to other submissions for “'+relname+'” by indicating which bins they fall within.</li><li>The percentages below the graph give the proportion of cases above and below '+$("#compare").val()+'cM. <small>(These are approximate percentages as they assume that cases within the arrowed bin are evenly spread)</small></li></ul>');

      }
      else {
        $("#hnote").html($("#hnote").html() + '<ul><li>The red arrow shows how this compares to other submissions for “'+relname+'” by indicating which bin it falls within.</li><li>The percentages below the graph give the proportion of cases above and below '+$("#compare").val()+'cM. <small>(These are approximate percentages as they assume that cases within the arrowed bin are evenly spread)</small></li></ul>');
      }

		}
		else {
			showArrows = false;
      var thisis = 'This is';
      if($.isNumeric($("#compare2").val())){
        thisis = 'One or both of these amounts are';
      }
			$("#hnote").html($("#hnote").html() + '<ul><li><strong style="color:#f00">'+thisis+' outside the recorded bounds (99th percentile) for “'+relname+'” in the shared cM project.</strong></li></ul>').css('display','block');
		}
		
		var lowerRunning = 0;
		var upperRunning = 0;
		var prevValue = 0;
		if(typeof(scm.hdata[mybins][currentIncrement-1])!=='undefined'){
			prevValue = scm.hdata[mybins][currentIncrement-1]
		}
		var interp = scm.hdata[myfreq][currentIncrement] * (currentcm - prevValue)/increment; // 
		//var interp = increment * (currentcm - scm.hdata[mybins][currentIncrement-1])/increment; // 

		for(var i in scm.hdata[myfreq]){
			if(i < currentIncrement){
				lowerRunning +=parseInt(scm.hdata[myfreq][i]);
			}
			else {
				upperRunning +=parseInt(scm.hdata[myfreq][i]);
			}
		}
		//var totalCases = lowerRunning + upperRunning;
		lowerPerc = ((parseInt(lowerRunning) + parseInt(interp))/totalCases * 100).toFixed(1);
		//console.log((lowerRunning + interp)/totalCases * 100);
		if(lowerPerc > 5 && lowerPerc < 95){
			lowerPerc = Math.round(lowerPerc);
			upperPerc = Math.round(100-lowerPerc);
		}
		else {
			upperPerc = (100-lowerPerc).toFixed(1);
		}
		//console.log(lowerPerc);
		//console.log(upperPerc);
		var debug = false;
		if(debug){
			console.log('total cases: '+totalCases+'\nLower number: '+parseInt(lowerRunning + interp)+' ('+lowerPerc+')');
			console.log(showArrows);
			console.log(scm.hdata[mybins].length-1);
			console.log(currentIncrement)
		}	

		
		/*
		  <span id="hmeanvalue"></span> and an SD of <span id="hsdvalue"></span></li>
		*/	
//		var lowerPortion =  (((currentIncrement+.5)/scm.hdata[mybins].length * 100)+.9).toFixed(4); //5.5/scm.hdata[mybins].length +(.4)
		var lowerPortion =  (((currentIncrement+.5)/scm.hdata[mybins].length * 100)).toFixed(4)-.5; //5.5/scm.hdata[mybins].length +(.4)
		// the 
		var upperPortion = 99-lowerPortion; // allow for the spacer
		// TODO: if viewport is 500 or less currentIncrement is 0 or scm.hdata[mybins].length-1, strip out ' of cases'


		if((lowerPerc !=0 || upperPerc  !=0) && showArrows){
			 if(lowerPerc==0){
			 	lowerPerc = '~0';
			 }
		 	if(upperPerc==0){
			 	upperPerc = '~0';
			 }			 
			$("#PercChart").css('display','table');
			$("#higherPercChart").css('width',upperPortion+'%');
			$("#higherPercChart span").text(upperPerc+'% of cases');			
			$("#lowerPercChart").css('width',lowerPortion+'%');
			$("#lowerPercChart span").text(lowerPerc+'% of cases');
			if($("#histogram").width()<500){
				if(currentIncrement<2){
					$("#lowerPercChart span").text(lowerPerc+' %');				
				}
				else if(currentIncrement==scm.hdata[mybins].length-1){
					$("#higherPercChart span").text(upperPerc+' %');				
				}				
			}


		}
	} 
	else {
    	$("#hnote").text('').css('display','none');		
	}
		$("#htotalsub").text(totalCases);
		$("#hmeanvalue").text(scm.hdata[mymean]+"cM");
		$("#hsdvalue").text(scm.hdata[mysd]+"cM");


	
const ctx = 'myChart';
var mycolor = 'transparent';
if(currentcm){
	mycolor = 'red';
}

Chart.defaults.font.size = 16;
Chart.defaults.font.weight = 'bold';
var arrowSize = 36;
if($("#histogram").width()<500){
	Chart.defaults.font.size = 10;
	arrowSize = 24;
}

var leftLabelOffset = 0;
if(scm.hdata[mybins].length > 10 && parseInt(currentcm)>9){
	if(currentIncrement == scm.hdata[mybins].length-1 ){
		leftLabelOffset = -.3;
	}
	else if(currentIncrement ==0){
		leftLabelOffset = .18375;
	}
}

var myarrows = {
            label1: {
              type: 'label',
              xValue: currentIncrement + leftLabelOffset,
              yValue: scm.hdata[myfreq][currentIncrement]+(5*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement])),
          content: [currentcm+'cM'],
              color:mycolor,
              textAlign:'left',
              font: {
                weight:'bold'
              }
            },
            label2: {
              type: 'label',
              xValue: currentIncrement,
              yValue: scm.hdata[myfreq][currentIncrement]+3*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement]),          
              content: ['\u2b07\uFE0E'],

              color:mycolor,
              font: {
                size: arrowSize,
                weight:'bold',
              }
            }   
};

if(version=='-double' && typeof(currentIncrement2) !=='undefined' && currentIncrement2!=currentIncrement  && $("#compare2").val()!=''){
  myarrows = {
            label1: {
              type: 'label',
              xValue: currentIncrement + leftLabelOffset,
              yValue: scm.hdata[myfreq][currentIncrement]+(5*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement])),
          content: [currentcm+'cM'],
              color:mycolor,
              textAlign:'left',
              font: {
                weight:'bold'
              }
            },
            label2: {
              type: 'label',
              xValue: currentIncrement,
              yValue: scm.hdata[myfreq][currentIncrement]+3*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement]),          
              content: ['\u2b07\uFE0E'],

              color:mycolor,
              font: {
                size: arrowSize,
                weight:'bold',
              }
            },   
            label3: {
              type: 'label',
              xValue: currentIncrement2 + leftLabelOffset,
              yValue: scm.hdata[myfreq][currentIncrement2]+(5*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement2])),
            content: [$("#compare2").val()+'cM'],
              color:mycolor,
              textAlign:'left',
              font: {
                weight:'bold'
              }
            },
            label4: {
              type: 'label',
              xValue: currentIncrement2,
              yValue: scm.hdata[myfreq][currentIncrement2]+3*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement2]),          
              content: ['\u2b07\uFE0E'],

              color:mycolor,
              font: {
                size: arrowSize,
                weight:'bold',
              }
            }   
  };

  
}

else if(version=='-double' && $("#compare2").val()!=''){
  myarrows = {
            label1: {
              type: 'label',
              xValue: currentIncrement + leftLabelOffset,
              yValue: scm.hdata[myfreq][currentIncrement]+(6.25*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement])),
          content: [currentcm+'cM,'],
              color:mycolor,
              textAlign:'left',
              font: {
                weight:'bold'
              }
            },
            label1a: {
              type: 'label',
              xValue: currentIncrement + leftLabelOffset,
              yValue: scm.hdata[myfreq][currentIncrement]+(5*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement])),
          content: [$("#compare2").val()+'cM'],
              color:mycolor,
              textAlign:'left',
              font: {
                weight:'bold'
              }
            },            
            label2: {
              type: 'label',
              xValue: currentIncrement,
              yValue: scm.hdata[myfreq][currentIncrement]+3*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement]),          
              content: ['\u2b07\uFE0E'],

              color:mycolor,
              font: {
                size: arrowSize,
                weight:'bold',
              }
            },   
            label3: {
              type: 'label',
              xValue: currentIncrement2 + leftLabelOffset,
              yValue: scm.hdata[myfreq][currentIncrement2]+(5*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement2])),
            content: [$("#compare2").val()+'cM'],
              color:mycolor,
              textAlign:'left',
              font: {
                weight:'bold'
              }
            },
            label4: {
              type: 'label',
              xValue: currentIncrement2,
              yValue: scm.hdata[myfreq][currentIncrement2]+3*getArrowOffsetUnit(maxvalue, scm.hdata[myfreq][currentIncrement2]),          
              content: ['\u2b07\uFE0E'],

              color:mycolor,
              font: {
                size: arrowSize,
                weight:'bold',
              }
            }   
  };

  






}

const myChart = new Chart(ctx, {
    data: {
        labels: scm.hdata[mybins], //.concat([''])
        datasets: [{
		    type: 'bar',
            label: ' Submissions',
            data: scm.hdata[myfreq],
            backgroundColor: "#4F72C0" //699ad0
        }]
    },
	plugins: [ChartDataLabels],
    options: {
    	layout: {
        	padding: {
        		top:30,
        	}
        },
        barPercentage: 0.35,
        plugins: {
		      annotation: {
		  	   annotations: 	       
            myarrows		      
		    },
        	legend:{
        		display:false,
        		labels: {
        			font: {
        				size:16,
			            weight:'normal',

        			}
        		}
        	},        	
        	datalabels: {
				align: 'top',
        		anchor: 'end',
        		font: {
        			weight: 'normal',
        			color: '#4F72C0'

        		}      		
        	},

			tooltip: {
				bodyFont: {
        			weight: 'normal',
        			size: 14,

        		} ,
        		callbacks: {
        			title: function(context){
        				//console.log(increment);
                return (parseInt(context[0].label)-increment+1)+'\u2009'+'–\u2009'+context[0].label+'cM';
                //return 'Bin: '+context[0].label+'cM';
        		}
        	}
        }
			
        },
       
        scales: {
 			x: {
            	ticks: {
                	autoSkip: false
 	           	},
 	           	grid: {
            		display:false
        		}
    	    },
            y: {
                 type: 'linear',
          		grace: '10%',
                beginAtZero: true,
				grid: {
          			drawBorder: false,
        		},
				afterFit: function(scaleInstance) {
        			scaleInstance.width = 50; // sets the width to 100px
      			}        		
            }           
        }
    }
});
//console.log(yTicks[yTicks.length-1].value);
}

function getArrowOffsetUnit(maxvalue, currentvalue){
	var charth = .5*($('#histogram').width() - 40);
	var myval = (maxvalue / (charth-64)*20);
	if(maxvalue==currentvalue) { // there will be height added to the top so increment can be bigger maybe
		myval = (maxvalue / (charth-64)*22);
	}
	//console.log (2*myval);
	return myval;

}
/*function printOut(){
	$(".rels li").each(function(){
	var thisrel = $(this).find('strong').text();
	console.log(shortenRel(thisrel));
});
}*/


function shortenRel(rel){
  rel = rel.replace(' / ','');
  rel = rel.replace(' ','');
  rel = rel.replace(/-/g,'');

  if(rel=='Child'){
    return 'parent';
  }
  rel = rel.replace('child','parent');
  rel = rel.toLowerCase();
  rel = rel.replace('niecenephew','auntuncle');
  return rel;
}

function filterChart($enteredval) {
    var secondval = '';
    if($.isNumeric($("#compare2").val())){
         secondval = parseFloat($("#compare2").val());
    }
    if(typeof(secondval)=='number' && secondval < $enteredval){
      var higher = parseFloat($enteredval);
      $enteredval = secondval;
      secondval = higher;
    }
      var $rels = $(".rels li");
      if ($("#compare").val() == "" ) {
        resetChart();
      }
      $(".rels").addClass("filtered");
      if(version !='v2'){
        $(".hidebefore").css('display','block');
      }
      if(version =='-double'){
        $("#most-probable").css('display','none');
      }
      $rels
        .removeClass("is-animated")
        .fadeTo("fast", 0.25)
        .promise()
        .done(function() {
          $rels
            .filter(function(i) {
              return (
                $(this).attr("data-start") !== undefined &&
                $enteredval >= $(this).attr("data-start") &&
                $enteredval <= $(this).attr("data-end") &&
                (secondval =='' || (secondval >= $(this).attr("data-start") &&
                secondval <= $(this).attr("data-end")))
              );
            })
            .addClass("is-animated")
            .fadeTo("fast", 1);
            if(version =='-double'){
        
                $(".cm1").text($enteredval+'cM');
                $(".cm2").text(secondval+'cM');
              var matchingrels = $(".is-animated").length;
              if(secondval =='' && secondval !='0' && !isNaN($enteredval)){
            
                $("#cmnone").css('display','none');
                $("#cmone").css('display','block');
                $("#cmboth").css('display','none');
              }
              else if(isNaN($enteredval)) {

                $("#cmnone").css('display','none');
                $("#cmone").css('display','none');
                $("#cmboth").css('display','none');          
              }    

              else if(matchingrels){
                $("#cmone").css('display','none');
                $("#cmnone").css('display','none');
                $("#cmboth").css('display','block');
              }
              else if(secondval !='') {

                $("#cmnone").css('display','block');
                $("#cmone").css('display','none');
                $("#cmboth").css('display','none');
              } 
              else {

                $("#cmnone").css('display','none');
                $("#cmone").css('display','none');
                $("#cmboth").css('display','none');          
              }       
              if(!isNaN($enteredval)){
              $("#doublenote").css('display', 'block');
                
              }
            }


        });

      if(version=='v4' || version=='v9' || version=='v4-beta' || version=='v4mdca' ){

          setTimeout(function() {
            var $matchingrels = ($("li.is-animated"));
            getCollatedProbabilityList($enteredval, $matchingrels);
          }, 250);  
       // }
      }
      //setTimeout(function(){
    
    //},200);
}


function sortObject(obj) {
    var myobj = (Object.keys(obj).sort(function(a, b){
      return parseFloat(b.replace(/^(.*)_/,"")) - parseFloat(a.replace(/^(.*)_/,""));

    }));

    return myobj.reduce(function (result, key) {
        result[key] = obj[key];
        return result;
    }, {});
}

function compareArrays(arr1, arr2) {
    return $(arr1).not(arr2).length == 0 && $(arr2).not(arr1).length == 0
};

function getLowCm(amount){
    if(amount < 10 
     && amount.toString().indexOf('.') > -1
    ){
      return true;
    }
    return false;
}

function getCollatedProbabilityList(amount, relationships){
    var allrels = [];
   $(".rels li").each(function(index){
        var myrel = $(this).find('strong').text();
        var mycm = $(this).find('span').text();
        // if not empty and has a number, it's a real rel
        if(myrel!='' && mycm !=''){allrels.push(myrel);}
    });
    $("#most-probable-rels").empty();

    if(!$.isNumeric(amount)){
      return;
    }
    var relstoshow = [];
    var groupsused = [];    
    var scmrels = [];
    var mdca = null;
    var lowestmdca = null;
    var hasDistantRel = false;
    var hasextragroupitems = false;
    var mostDistantRel = '';
    $(relationships).each(function(index){

        if(!$(relationships[index]).hasClass('rel-dupe')){
          var rel = $(relationships[index]).find('strong').text();
          scmrels.push(rel);          
        }
    });
    for (var s in scmrels){
      var rel = scmrels[s];
      var thisgroup = getSCMGroup(rel);
      var thismdca = getMDCA(rel);
      var thisdistance = getDistance(rel);
      var thisprob = getProbability(amount, rel);


      if(parseInt(thismdca) < lowestmdca && thisdistance < 4){
        lowestmdca = parseInt(thismdca);
      }      

      if(thisprob > 1 && (parseInt(thismdca) > mdca || mdca ==null)){
        mdca = parseInt(thismdca);
        mostDistantRel = rel;
      }      
      var thisprobvalue = '';
      if(thisprob=='0.00'){
        thisprobvalue = '~ 0';
      }
      else{
        thisprobvalue = thisprob;
      }


      if(typeof(relstoshow[thisgroup+'_'+thisprob])==='undefined'){
        relstoshow[thisgroup+'_'+thisprob] = '';
      }

      if($.inArray(thisgroup,groupsused)==-1){
        groupsused.push(thisgroup);
        // get all relationships in this group
        var grouprels = getRels(thisgroup, true);    
    

        for (var r in grouprels){
          if($.inArray(grouprels[r].rel,scmrels)==-1 && thisprob !='0.00' && $.inArray(grouprels[r].rel,allrels)!=-1){
//          if($.inArray(grouprels[r].rel,scmrels)==-1 && thisprob !='0.00'){ commenting this in includes distant relationships not listed on the scm page

            // found an item not in shared cm but in the data. output it.
            relstoshow[thisgroup+'_'+thisprob] += '<em tabindex="0">'+grouprels[r].rel+' &#8224;</em> ';
            hasextragroupitems = true;
            // if a 1% chance or more
            if(thisprob > 1){
              var thismdca = getMDCA(grouprels[r].rel);
              var thisdistance = getDistance(rel);

              if(parseInt(thismdca) > mdca || mdca ==null){
                mdca = parseInt(thismdca);
                mostDistantRel = grouprels[r].rel;
              }
              if(thisprob > 10 && thisdistance < 4 && parseInt(thismdca) < lowestmdca){
                lowestmdca = parseInt(thismdca);
              } 

            }
           

          }
        }
      
      }


    if(rel=='8C'){
      rel = '8C or more distant';
      hasDistantRel = true;
    }
      
     relstoshow[thisgroup+'_'+thisprob] += '<em tabindex="0">'+rel+'</em> ';


    }

  
    var totalprob = 0;
    var masterlist = '';
    for (var i in relstoshow) {
      var arr = i.split('_');
      var number = arr[1];
      totalprob +=parseFloat(number);
      // produce the array first and then output it all at once so we can sort.         
    }
  groupsused = $.unique(groupsused);  

  // before I go and get additional groups, check for missing rels in the existing groups
  // (dec 2022 cough cough)

  // OK now I need to go into the group and check if there are any other relationships that need to be output
  // make an array of the Relationships that are in thisgroup
  for(var g in groupsused){
    // for each of these groups, append any relationships that are in the Relationships array for that group but are not in the main list.
    // OR just do this earlier.
  }

  var hasadditional = false;
  // now I can check totalprob and if it's less than 100, I'll need to add some in!
  if(parseFloat(totalprob.toFixed(1)) < 100){
    var newprobs = getAdditionalProbabilities(amount, groupsused);
    if(newprobs){
      $.extend(relstoshow, newprobs);
      hasadditional = true;
    }


  }
  relstoshow = sortObject(relstoshow);

  var printprob = '';
  var exception23andme = false;
    for (var i in relstoshow) {
      var arr = i.split('_');
      var number = arr[1];
      var dupe = false;

      if(parseFloat(number).toFixed(2)==printprob || (parseInt(Math.round(parseFloat(number)))==printprob)){
        dupe = true;
      }
      printprob = parseFloat(number).toFixed(2);
      if(printprob >=1){
        printprob = parseInt(Math.round(printprob));
      }
     
          if(number=='0.00'){
            printprob = '~ 0';
          }

          var markup = '<li ';
          if(dupe){
          markup +='class = \'dupe\' ';
          }
          markup += 'style=\'background:rgba(204,204,204,'+(number/100)+'\'><strong>';
          //if(!dupe){
            markup += printprob+'%';
          //}
          /*else {
            markup += '&#160;&#160;';

          }*/
          markup +='</strong><span>';

           if(number=='0.00'){
            markup +='** ';
          }
          markup += relstoshow[i];          
          markup +='</span></li>';
          if(relstoshow[i]=='<em tabindex="0">Parent</em> <em tabindex="0">Child</em> ' && parseInt(number) >90){
            exception23andme = true;
          }
          var hasexceptions = false;
          if(number=='0.00'){
            hasexceptions = true;
          }
          masterlist += markup;
  }
 if(hasadditional){
      masterlist +='<li style="background:rgba(204,204,204,.25)"><small>* this set of relationships has a positive probability for '+amount+'cM in thednageek\'s <a target="_blank" href="https://thednageek.com/the-limits-of-predicting-relationships-using-dna/">table of probabilities</a>, but falls outside the bounds of the shared cM project (99th percentile)</small></li>';
  } 
  if(exception23andme){
      masterlist +='<li style="background:rgba(204,204,204,.25)"><small style="font-size:14px; font-weight:bold; color:#535343">Important: if you have cM amounts from 23andMe, these will count fully identical areas twice. This can mean sibling relationships show as parent/child in this tool.</small></li>';
  }   

  if(hasexceptions){
      masterlist +='<li class="double_ast" style="background:rgba(204,204,204,.25)"><small>** this set of relationships is just within the threshold for '+amount+'cM, but has a zero probability in thednageek\'s <a target="_blank" href="https://thednageek.com/the-limits-of-predicting-relationships-using-dna/">table of probabilities</a></small></li>';
  }  
  if(hasextragroupitems){
      masterlist +='<li style="background:rgba(204,204,204,.25)"><small>&#8224; this relationship has a positive probability for '+amount+'cM in thednageek\'s <a target="_blank" href="https://thednageek.com/the-limits-of-predicting-relationships-using-dna/">table of probabilities</a>, but falls outside the bounds of the recorded cM range (99th percentile)</small></li>';
  }


  var enteredcm = parseFloat($("#compare").val());
  $("#low-notice, #gt20, #lt20").css('display','none');
  var lowcm = getLowCm(amount);
  if(lowcm){
    $("#low-notice").css('display','block');  
    $(".ienteredcM").text(amount);
    $("#ienteredC").attr('href','/tools/sharedcm'+version+'/'+getcMsFromPercentage(amount));
    $("#zero-notice").css('display','none');  
  }
  else if(enteredcm< 1){
    $("#mdca-area").css('display','none');
    $("#zero-notice").css('display','block');
  }
  else {
    $("#mdca-area").css('display','block');
    $("#zero-notice").css('display','none');

  }
  $(".enteredcm").text(enteredcm);
  $("#most-probable-rels").append(masterlist);
  if(enteredcm >20){
    $("#gt20").css('display','block');
    $("#mdca-string").html(getMDCAString(mdca, parseInt(enteredcm), lowestmdca, hasDistantRel, mostDistantRel));
  }
  else {
    $("#lt20").css('display','block');
  }
 
  }
  function getGenString(mdca){
    if(mdca > 0){
      return ' <span> or generation '+(mdca+3)+' on your pedigree chart</span>';
    }
    return false;
  }

  function getMDCATooltip(rel){
    var tt = 'Based on the most distant relationships with a probability of over 1%, such as '+rel;
    return tt;

  }
  function getMDCAString(mdca, enteredcm, lowestmdca, hasDistantRel, mostDistantRel){
   
   var mystring = '<span class="scmtt">';
    $("#mdca-main").text('might need');
  
   if(mdca >= 0 ){
    if(mdca==2){
      mystring += '2nd-';
    }
    else if(mdca==3){
      mystring += '3rd-';
    }
    else if(mdca > 3) {
      mystring += mdca+'th-';
    }
    if(mdca > 0){
      mystring +='Great-'
    }
    mystring +='Grandparent level';
    if(mdca >= 0){

    mystring += '<span>'+getMDCATooltip(mostDistantRel)+'</span></span>';
    }

     var genstring = getGenString(mdca);
      if(genstring){
        mystring += genstring;
      }
      mystring +='.';

    mystring +='<em><strong>The connection ';
    if(hasDistantRel){
      mystring +='could'; 
    }
    else {
      mystring +='may'; 
    }
    mystring +=' be closer. </strong>';
   }
   else {
    mystring += 'Parent level';
    mystring += '<span>This is a close relative</span></span>';
    mystring +='<em>';
   }
   if(enteredcm <=15) {
    //console.log('booooo');
    //$("#mdca-main").text('might');

   }
   if(hasDistantRel){
    mystring += 'However, it could date much further back to beyond the genealogical timeframe.';
   }
   if(lowestmdca < 0 && parseInt(enteredcm) < 2300){
    mystring += 'Also, depending on your family, this match could be a close younger generation relative, such as the descendant of your sibling.';
   }
   if(parseInt(enteredcm)<=10){
    mystring += ' It\'s also worth bearing in mind that some segments at this level are false.';
   }
   mystring += '</em>';
   


   return mystring;
  }
function getAdditionalProbabilities(amount, groupstoexclude){
  //console.log(groupstoexclude);
  // go into the Likelihoods array and get interpolated values for all groups not in groupstoexclude
  var allgroups = ["A","B","C","D","E","F","G","H","I","J","J+","J++"];
  var relstoshow = [];
  var mastermarkup = '';
  var gotsome = false;
  for(var i in allgroups){
    var thisgroup = allgroups[i];
    if($.inArray(thisgroup,groupstoexclude)==-1){
      // it's not in there
      // check the value. If it's > 0, output a row
      var prob = getInterpolatedProb(amount,thisgroup);
      if(prob >0){
        // need to get list of rels out of i =- do this later
        var printgroups = getRels(thisgroup, false);
        relstoshow[thisgroup+'_'+prob] = '* '+printgroups;
        gotsome = true;
      }
    }    
  }
  if(gotsome){
    return relstoshow;
  }
  return false;

}

 function getRels(group, arrayonly){
  // take a group and return the rels formatted
  var myrels = Relationships.filter(function(Relationships) {
            return Relationships.group == group;
        });
  if(arrayonly){
    return myrels;
  }
  var relstring = '';
  for(var i in myrels){
    relstring +='<em tabindex="0">'+myrels[i].rel+'</em> ';
  }
  return relstring;
 }

 function getSCMGroup(rel){
   // take a rel and return the group
  var thisrel = Relationships.filter(function(Relationships) {
            return Relationships.rel == rel;
        });
  if(typeof(thisrel[0])==='undefined'){
    return false;
  }
  return thisrel[0].group;
 }

 function getMDCA(rel){
   // take a rel and return the most distant common ancestor
  var thisrel = Relationships.filter(function(Relationships) {
            return Relationships.rel == rel;
        });
  if(typeof(thisrel[0])==='undefined'){
    return false;
  }
  return thisrel[0].mdca;
 }

 function getDistance(rel){
  var thisrel = Relationships.filter(function(Relationships) {
            return Relationships.rel == rel;
        });
  if(typeof(thisrel[0])==='undefined'){
    return false;
  }
  return thisrel[0].distance;
 }
 



function getProbability(amount, rel){

  var thisrel = Relationships.filter(function(Relationships) {
            return Relationships.rel == rel;
        });
  if(typeof(thisrel[0])==='undefined'){
    return false;
  }
  var thisgroup = thisrel[0].group;
  var prob = getInterpolatedProb(amount,thisgroup);
  return prob;
}

function getNearestProb(amount, group){
  // find array item in likelihoods that is closest to amount
  // return the appropriate value.
  var amounttouse = closest(amount, Likelihoods);
  var thisprob = Likelihoods.filter(function(Likelihoods) {
            return Likelihoods.cm == amounttouse;
        });
 
  var perc = (thisprob[0][group]*100)
  perc = parseFloat(perc).toFixed(2);
  return perc;
}

function getAdjacentLikelihoods (num, arr) {
  var curr = parseInt(arr[0].cm);
  var diff = Math.abs (num - curr);
  for (var val = 0; val < arr.length; val++) {
      var newdiff = Math.abs (num - arr[val].cm);
      if (newdiff <= diff) {
        diff = newdiff;
        curr = [];
        if(num < arr[val].cm){
          curr.first = arr[val-1].cm;
          curr.last = arr[(val)].cm;
        }
        else if(num > arr[val].cm){
          curr.first = arr[val].cm;
          if(typeof(arr[val+1])==='undefined'){
            curr.last = arr[val].cm;
          }
          else {
          curr.last = arr[val+1].cm;
          }
        }
      }
    }
  return curr;
    }  


function getInterpolatedProb(amount, group){
  // return an interpolated probability value based on the entered number
  var amounttouse = closest(amount, Likelihoods);
  var directhit = Likelihoods.filter(function(Likelihoods) {
            return parseFloat(Likelihoods.cm) == parseFloat(amount);
        });
  if(directhit.length==1){
    return parseFloat(directhit[0][group]*100).toFixed(2);
  }
  var amountstouse = getAdjacentLikelihoods(amount, Likelihoods);
  var spread = amountstouse.last - amountstouse.first;
  
  var startprob = Likelihoods.filter(function(Likelihoods) {
            return Likelihoods.cm == amountstouse.first;
        });
  var endprob = Likelihoods.filter(function(Likelihoods) {
            return Likelihoods.cm == amountstouse.last;
        });  

  var result =((amountstouse.last - amount)*startprob[0][group] + (amount - amountstouse.first)*endprob[0][group]) / (amountstouse.last - amountstouse.first);
  if(spread==0){
    result = 0;
  }

  var thisprob = Likelihoods.filter(function(Likelihoods) {
            return Likelihoods.cm == amounttouse;
        });
 
  var perc = (parseFloat(result)*100)
  perc = parseFloat(perc).toFixed(2);

  return perc;
}

function closest (num, arr) {
  var curr = parseInt(arr[0].cm);
  var diff = Math.abs (num - curr);
  for (var val = 0; val < arr.length; val++) {
      var newdiff = Math.abs (num - arr[val].cm);
      if (newdiff < diff) {
        diff = newdiff;
        curr = arr[val].cm;
      }
    }
  return curr;
    }

function resetChart() {
  $("#percentagecompare").val('');  
  if($.isNumeric($("#compare").val())){
    setTimeout(function(){
      filterChart(parseFloat($("#compare").val()));
    },600);

  }
  $(".rels").removeClass("filtered");
  $(".hidebefore, #doublenote").css('display','none');
  $("#most-probable-rels").html('<li>Enter a number above to see probabilities</li>');
  $(".rels li").removeClass("is-animated").fadeOut().promise().done(function() {
    $(".rels li").addClass("is-animated").fadeTo("fast", 1);
    $("#currentamount").attr('href',siteurl+'/tools/sharedcm/');
  });
}


/*
labels is the bins,
data is the frequency
*/


scm = {};
scm.hdata = {};
scm.hdata.rels = {};
scm.hdata.r_parent_bins = [2300,2400,2500,2600,2700,2800,2900,3000,3100,3200,3300,3400,3500,3600,3700,3800,3900,4000];
scm.hdata.r_parent_freq = [0,1,2,0,3,3,2,0,2,1,7,742,746,733,28,142,0];
scm.hdata.r_parent_mean = 3485;
scm.hdata.r_parent_sd = 114;
scm.hdata.r_sibling_bins = [1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600,2700,2800,2900,3000,3100,3200,3300,3400,3500,3600,3700,3800,3900];
scm.hdata.r_sibling_freq = [0,9,6,8,10,9,18,56,155,333,521,566,425,218,91,19,6,1,9,5,0,0,0];
scm.hdata.r_sibling_mean = 2613;
scm.hdata.r_sibling_sd = 203;
scm.hdata.r_halfsibling_bins = [1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600];
scm.hdata.r_halfsibling_freq = [0,6,20,33,80,117,226,245,234,158,87,37,14,6,3,0];
scm.hdata.r_halfsibling_mean = 1759;
scm.hdata.r_halfsibling_sd = 207;
scm.hdata.r_auntuncle_bins = [1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400];
scm.hdata.r_auntuncle_freq = [0,26,66,158,333,513,605,486,311,144,41,12,0];
scm.hdata.r_auntuncle_mean = 1741;
scm.hdata.r_auntuncle_sd = 180;
scm.hdata.r_halfauntuncle_bins = [400,500,600,700,800,900,1000,1100,1200,1300,1400,1500,1600];
scm.hdata.r_halfauntuncle_freq = [0,3,42,82,144,188,182,100,51,20,3,0];
scm.hdata.r_halfauntuncle_mean = 871;
scm.hdata.r_halfauntuncle_sd = 165;
scm.hdata.r_grandparent_bins = [900,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600];
scm.hdata.r_grandparent_freq = [0,2,4,12,22,35,69,110,196,199,174,128,85,28,28,11,3,0];
scm.hdata.r_grandparent_mean = 1754;
scm.hdata.r_grandparent_sd = 236;
scm.hdata.r_halfgreatauntuncle_bins = [150,200,250,300,350,400,450,500,550,600,650,700,750];
scm.hdata.r_halfgreatauntuncle_freq = [0,1,9,15,28,47,46,28,28,18,15,3,0];
scm.hdata.r_halfgreatauntuncle_mean = 431;
scm.hdata.r_halfgreatauntuncle_sd = 105;
scm.hdata.r_halfggauntuncle_bins = [100,125,150,175,200,225,250,275,300,325];
scm.hdata.r_halfggauntuncle_freq = [0,1,2,4,9,9,1,5,3,0];
scm.hdata.r_halfggauntuncle_mean = 208;
scm.hdata.r_halfggauntuncle_sd = 43;
scm.hdata.r_half3c3r_bins = [10,20,30,40,50];
scm.hdata.r_half3c3r_freq = [2,8,3,1,0];
scm.hdata.r_half3c3r_mean = 0;
scm.hdata.r_half3c3r_sd = 0;
scm.hdata.r_half3c2r_bins = [10,20,30,40,50,60,70,80,90];
scm.hdata.r_half3c2r_freq = [6,13,18,10,5,1,1,1,0];
scm.hdata.r_half3c2r_mean = 27;
scm.hdata.r_half3c2r_sd = 15;
scm.hdata.r_half3c1r_bins = [10,20,30,40,50,60,70,80,90,100,110,120,130,140,150];
scm.hdata.r_half3c1r_freq = [19,43,57,50,29,15,15,8,2,3,3,2,2,1,0];
scm.hdata.r_half3c1r_mean = 37;
scm.hdata.r_half3c1r_sd = 24;
scm.hdata.r_half3c_bins = [25,50,75,100,125,150,175,200];
scm.hdata.r_half3c_freq = [75,117,61,21,19,3,6,0];
scm.hdata.r_half3c_mean = 48;
scm.hdata.r_half3c_sd = 33;
scm.hdata.r_half2c2r_bins = [25,50,75,100,125,150,175];
scm.hdata.r_half2c2r_freq = [29,29,23,9,4,4,0];
scm.hdata.r_half2c2r_mean = 48;
scm.hdata.r_half2c2r_sd = 32;
scm.hdata.r_half2c1r_bins = [25,50,75,100,125,150,175,200,225];
scm.hdata.r_half2c1r_freq = [60,128,128,60,52,34,8,4,0];
scm.hdata.r_half2c1r_mean = 66;
scm.hdata.r_half2c1r_sd = 39;
scm.hdata.r_half2c_bins = [25,50,75,100,125,150,175,200,225,250,275,300,325,350];
scm.hdata.r_half2c_freq = [22,45,72,68,96,60,54,39,25,13,7,7,4,0];
scm.hdata.r_half2c_mean = 120;
scm.hdata.r_half2c_sd = 62;
scm.hdata.r_half1c3r_bins = [25,50,75,100,125,150];
scm.hdata.r_half1c3r_freq = [4,9,9,7,4,0];
scm.hdata.r_half1c3r_mean = 60;
scm.hdata.r_half1c3r_sd = 32;
scm.hdata.r_half1c2r_bins = [25,50,75,100,125,150,175,200,225,250,275,300];
scm.hdata.r_half1c2r_freq = [2,13,22,17,32,20,29,18,7,3,2,0];
scm.hdata.r_half1c2r_mean = 125;
scm.hdata.r_half1c2r_sd = 54;
scm.hdata.r_half1c1r_bins = [50,100,150,200,250,300,350,400,450,500,550];
scm.hdata.r_half1c1r_freq = [0,19,89,148,159,83,56,34,15,2,0];
scm.hdata.r_half1c1r_mean = 224;
scm.hdata.r_half1c1r_sd = 80;
scm.hdata.r_half1c_bins = [100,200,300,400,500,600,700,800,900,1000,1100];
scm.hdata.r_half1c_freq = [0,9,63,180,243,119,44,16,11,6,0];
scm.hdata.r_half1c_mean = 449;
scm.hdata.r_half1c_sd = 134;
scm.hdata.r_greatgreatauntuncle_bins = [100,200,300,400,500,600,700,800,900];
scm.hdata.r_greatgreatauntuncle_freq = [0,2,27,32,38,30,7,1,0];
scm.hdata.r_greatgreatauntuncle_mean = 420;
scm.hdata.r_greatgreatauntuncle_sd = 121;
scm.hdata.r_greatgrandparent_bins = [400,500,600,700,800,900,1000,1100,1200,1300,1400,1500,1600];
scm.hdata.r_greatgrandparent_freq = [0,1,4,15,31,28,35,19,7,5,2,2,0];
scm.hdata.r_greatgrandparent_mean = 887;
scm.hdata.r_greatgrandparent_sd = 181;
scm.hdata.r_greatauntuncle_bins = [300,400,500,600,700,800,900,1000,1100,1200,1300,1400,1500,1600];
scm.hdata.r_greatauntuncle_freq = [0,7,24,39,68,176,201,161,94,43,15,4,1,0];
scm.hdata.r_greatauntuncle_mean = 850;
scm.hdata.r_greatauntuncle_sd = 118;
scm.hdata.r_8c_bins = [10,20,30,40,50,60];
scm.hdata.r_8c_freq = [142,81,13,2,1,0];
scm.hdata.r_8c_mean = 11;
scm.hdata.r_8c_sd = 5;
scm.hdata.r_7c1r_bins = [10,20,30,40,50,60];
scm.hdata.r_7c1r_freq = [175,113,29,8,5,0];
scm.hdata.r_7c1r_mean = 12;
scm.hdata.r_7c1r_sd = 7;
scm.hdata.r_7c_bins = [10,20,30,40,50,60,70];
scm.hdata.r_7c_freq = [113,104,28,7,3,3,0];
scm.hdata.r_7c_mean = 14;
scm.hdata.r_7c_sd = 9;
scm.hdata.r_6c2r_bins = [10,20,30,40,50,60];
scm.hdata.r_6c2r_freq = [74,61,21,3,2,0];
scm.hdata.r_6c2r_mean = 13;
scm.hdata.r_6c2r_sd = 8;
scm.hdata.r_6c1r_bins = [10,20,30,40,50,60,70];
scm.hdata.r_6c1r_freq = [170,174,70,16,9,2,0];
scm.hdata.r_6c1r_mean = 15;
scm.hdata.r_6c1r_sd = 9;
scm.hdata.r_6c_bins = [10,20,30,40,50,60,70,80,90];
scm.hdata.r_6c_freq = [140,172,64,38,15,5,5,2,0];
scm.hdata.r_6c_mean = 18;
scm.hdata.r_6c_sd = 13;
scm.hdata.r_5c3r_bins = [10,20,30,40];
scm.hdata.r_5c3r_freq = [14,15,5,0];
scm.hdata.r_5c3r_mean = 13;
scm.hdata.r_5c3r_sd = 7;
scm.hdata.r_5c2r_bins = [10,20,30,40,50,60,70,80];
scm.hdata.r_5c2r_freq = [71,97,47,11,8,7,1,0];
scm.hdata.r_5c2r_mean = 18;
scm.hdata.r_5c2r_sd = 12;
scm.hdata.r_5c1r_bins = [10,20,30,40,50,60,70,80,90];
scm.hdata.r_5c1r_freq = [262,325,178,96,49,37,21,7,0];
scm.hdata.r_5c1r_mean = 21;
scm.hdata.r_5c1r_sd = 15;
scm.hdata.r_5c_bins = [10,20,30,40,50,60,70,80,90,100,110,120,130];
scm.hdata.r_5c_freq = [213,353,246,120,80,52,31,19,5,6,2,3,0];
scm.hdata.r_5c_mean = 25;
scm.hdata.r_5c_sd = 18;
scm.hdata.r_4c3r_bins = [10,20,30,40,50,60,70,80];
scm.hdata.r_4c3r_freq = [22,32,19,11,3,1,1,0];
scm.hdata.r_4c3r_mean = 19;
scm.hdata.r_4c3r_sd = 12;
scm.hdata.r_4c2r_bins = [10,20,30,40,50,60,70,80,90,100,110];
scm.hdata.r_4c2r_freq = [140,200,132,63,26,22,9,5,4,2,0];
scm.hdata.r_4c2r_mean = 22;
scm.hdata.r_4c2r_sd = 16;
scm.hdata.r_4c1r_bins = [10,20,30,40,50,60,70,80,90,100,110,120,130,140];
scm.hdata.r_4c1r_freq = [335,671,531,342,217,133,62,34,15,18,16,5,4,0];
scm.hdata.r_4c1r_mean = 28;
scm.hdata.r_4c1r_sd = 20;
scm.hdata.r_4c_bins = [10,20,30,40,50,60,70,80,90,100,110,120,130,140,150];
scm.hdata.r_4c_freq = [245,579,582,433,330,222,148,78,44,42,19,20,4,6,0];
scm.hdata.r_4c_mean = 35;
scm.hdata.r_4c_sd = 23;
scm.hdata.r_3c3r_bins = [10,20,30,40,50,60,70,80,90,100,110];
scm.hdata.r_3c3r_freq = [17,35,23,8,10,6,3,2,1,1,0];
scm.hdata.r_3c3r_mean = 27;
scm.hdata.r_3c3r_sd = 19;
scm.hdata.r_3c2r_bins = [10,20,30,40,50,60,70,80,90,100,110,120,130,140,150,160,170,180];
scm.hdata.r_3c2r_freq = [96,219,186,140,111,69,53,21,10,23,10,9,8,3,1,5,1,0];
scm.hdata.r_3c2r_mean = 36;
scm.hdata.r_3c2r_sd = 27;
scm.hdata.r_3c1r_bins = [25,50,75,100,125,150,175,200,225];
scm.hdata.r_3c1r_freq = [1140,1686,955,387,208,96,30,12,0];
scm.hdata.r_3c1r_mean = 48;
scm.hdata.r_3c1r_sd = 32;
scm.hdata.r_3c_bins = [25,50,75,100,125,150,175,200,225,250,275];
scm.hdata.r_3c_freq = [425,1311,1154,689,604,304,149,84,46,9,0];
scm.hdata.r_3c_mean = 73;
scm.hdata.r_3c_sd = 43;
scm.hdata.r_2c3r_bins = [25,50,75,100,125,150,175,200];
scm.hdata.r_2c3r_freq = [35,60,39,14,8,6,1,0];
scm.hdata.r_2c3r_mean = 51;
scm.hdata.r_2c3r_sd = 32;
scm.hdata.r_2c2r_bins = [25,50,75,100,125,150,175,200,225,250,275];
scm.hdata.r_2c2r_freq = [156,408,302,205,168,89,49,19,7,1,0];
scm.hdata.r_2c2r_mean = 71;
scm.hdata.r_2c2r_sd = 42;
scm.hdata.r_2c1r_bins = [25,50,75,100,125,150,175,200,225,250,275,300,325,350,375,400];
scm.hdata.r_2c1r_freq = [89,500,725,667,1020,791,563,400,227,151,82,35,17,10,4,0];
scm.hdata.r_2c1r_mean = 122;
scm.hdata.r_2c1r_sd = 59;
scm.hdata.r_2c_bins = [0,50,100,150,200,250,300,350,400,450,500,550,600,650];
scm.hdata.r_2c_freq = [0,23,162,534,943,1001,761,386,197,92,50,14,9,0];
scm.hdata.r_2c_mean = 229;
scm.hdata.r_2c_sd = 86;
scm.hdata.r_1c3r_bins = [0,25,50,75,100,125,150,175,200,225,250,275];
scm.hdata.r_1c3r_freq = [0,1,15,28,33,46,23,29,17,8,2,0];
scm.hdata.r_1c3r_mean = 117;
scm.hdata.r_1c3r_sd = 48;
scm.hdata.r_1c2r_bins = [0,50,100,150,200,250,300,350,400,450,500,550];
scm.hdata.r_1c2r_freq = [0,9,63,173,261,265,216,119,55,21,5,0];
scm.hdata.r_1c2r_mean = 221;
scm.hdata.r_1c2r_sd = 83;
scm.hdata.r_1c1r_bins = [100,200,300,400,500,600,700,800,900,1000,1100];
scm.hdata.r_1c1r_freq = [0,97,374,1015,1196,701,235,55,18,9,0];
scm.hdata.r_1c1r_mean = 433;
scm.hdata.r_1c1r_sd = 123;
scm.hdata.r_1c_bins = [300,400,500,600,700,800,900,1000,1100,1200,1300,1400,1500];
scm.hdata.r_1c_freq = [0,2,34,108,342,653,870,680,419,147,52,30,0];
scm.hdata.r_1c_mean = 866;
scm.hdata.r_1c_sd = 161;
